<template>
  <div>
    <a-form layout="inline" :model="formState" style="margin-bottom: 10px">
      <a-form-item label="车型">
        <a-input
          v-model:value="formState.name"
          placeholder="输入检索车型"
          allow-clear
        />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="handelSearch">查询</a-button>
      </a-form-item>
      <a-form-item style="position: absolute; right: 30px">
        <a-button type="primary" @click="showAddModal">添加车型</a-button>
      </a-form-item>
    </a-form>
    <a-modal
      v-model:open="open"
      :title="isEdit ? '编辑车型' : '添加车型'"
      :footer="null"
      :destroyOnClose="true"
    >
      <add-modal
        :v-if="open"
        @submit="clickOk"
        :isEdit="isEdit"
        :editData="editData"
        :data="tableData"
      ></add-modal>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'need_record'">
          {{ codeToText(record.need_record, ['不需要', '需要']) }}
        </template>
        <template v-if="column.key === 'check_overweight'">
          {{ codeToText(record.check_overweight, ['不需要', '需要']) }}
        </template>
        <template v-if="column.key === 'show_cargo_type'">
          {{ codeToText(record.show_cargo_type, ['不显示', '显示']) }}
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a-button @click="showEditModal(record)">编辑</a-button>
            &nbsp;&nbsp;
            <a-popconfirm
              title="确认删除？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="delRow(record)"
            >
              <a-button danger>删除</a-button>
            </a-popconfirm>
          </span>
        </template>
      </template>
    </a-table>
  </div>
</template>
<script setup>
  import { ref, reactive, onMounted } from 'vue'
  import { getModal, deleteModal } from '@/api/system_manage/modal'
  import AddModal from './addModal'
  import { message } from 'ant-design-vue'
  import { codeToText } from '@/utils/format'

  //1、搜索框
  const formState = reactive({
    name: '',
  })
  function handelSearch() {
    pagination.value.current = 1
    fetch()
  }

  //2、表格
  const columns = [
    {
      title: '车型',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
    },
    {
      title: '车速(km/h)',
      dataIndex: 'speed',
      key: 'speed',
      align: 'left',
    },
    {
      title: '预约需要备案',
      dataIndex: 'need_record',
      key: 'need_record',
      align: 'left',
    },
    {
      title: '页面是否显示货物类型',
      dataIndex: 'show_cargo_type',
      key: 'show_cargo_type',
      align: 'left',
    },
    {
      title: '判断超重',
      dataIndex: 'check_overweight',
      key: 'check_overweight',
      align: 'left',
    },

    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function fetch() {
    loading.value = true
    getModal({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
    })
  }
  onMounted(fetch)

  //3、编辑、添加
  const open = ref(false)
  const isEdit = ref(false)
  const editData = ref(null)

  const showAddModal = () => {
    editData.value = null
    isEdit.value = false
    open.value = true
  }
  const showEditModal = (data) => {
    editData.value = data
    isEdit.value = true
    open.value = true
  }

  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  //4、删除
  async function delRow(data) {
    const res = await deleteModal({ id: data.id })
    if (res.success) {
      message.success('删除成功！')
      fetch()
    } else {
      message.warn('删除失败' + res.message)
    }
  }
</script>
